import React from 'react'
import Layout from '../../common/Layout'
import MobileUnsupported from '../../features/MobileUnsupported/MobileUnsupported'

export default {
  path: '/mobile/feature',
  async action ({ params }) {
    return <Layout containerWell>
      <MobileUnsupported />
    </Layout>
  }
}
